import React from "react";
import Joi from "joi-browser";
import Form from "../common/form/form";
import { getUser, saveUser } from "./../../services/userService";
import { getCurrentUser } from "./../../services/authService";

class ProfileForm extends Form {
  state = {
    data: {
      id: -1,
      name: "",
      email: "",
      password: "",
      isAdmin: false
    },
    errors: {}
  };

  schema = {
    id: Joi.number(),
    name: Joi.string().required(),
    email: Joi.string().required(),
    password: Joi.string().required(),
    isAdmin: Joi.boolean()
  };

  async componentDidMount() {
    const history = this.props;

    const currentUser = await getCurrentUser();
    const user = await getUser(currentUser.id);
    if (!user) return history.replace("/not-found");

    this.setState({ data: this.mapToViewModel(user) });
  }

  mapToViewModel(user) {
    return {
      id: user.id,
      name: user.name,
      email: user.email,
      password: user.password,
      isAdmin: user.isAdmin
    };
  }

  doSubmit = async () => {
    await saveUser(this.state.data);
    this.props.history.push("/logout");
  };

  render() {
    return (
      <div>
        <h2>Profile</h2>
        <form onSubmit={this.handleSubmit}>
          {this.renderButton("fa fa-save", "btn btn-success m-1")}
          {this.renderInput("email", "e-mail (login)", false, "text", false)}
          {this.renderInput("name", "Name", true, "text", false)}
          {this.renderInput(
            "password",
            "Password",
            false,
            "password",
            !this.state.data.isAdmin
          )}
        </form>
      </div>
    );
  }
}

export default ProfileForm;



// WEBPACK FOOTER //
// ./src/components/users/profileForm.jsx